




import Vue from 'vue';
import Component from 'vue-class-component';

const SpacerProps = Vue.extend({
  props: {
    bgColor: {
      type: String,
      default: 'primary',
      validator: (val) => ['inverted', 'primary', 'theme'].includes(val),
    },
  },
});

@Component
export default class Spacer extends SpacerProps {
  get rootClasses () {
    return {
      'brandhub-spacer--color-inverted': this.bgColor === 'inverted',
      'brandhub-spacer--color-primary': this.bgColor === 'primary',
      'brandhub-spacer--color-theme': this.bgColor === 'theme',
    };
  }
}

